export default "__VITE_ASSET__D5sssI43__"